<template>
  <Flex align="center">
    <Flex :class="$style.progress">
      <BaseProgress :percentage="percentage" />
    </Flex>
    <BaseText>
      {{ $t(`marketing.insights.stats.${text}`, { amount: subValue }) }}
    </BaseText>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    mainValue: {
      type: Number,
      required: false,
    },
    subValue: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    percentage() {
      return this.mainValue
        ? Math.round((this.subValue / this.mainValue) * 100)
        : 0;
    },
  },
});
</script>

<style
  lang="scss"
  module
>

.progress {
  width: 60px;
}
</style>
